import { useEffect, useState } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'

import { Button } from '../components/Button'
import { useAuth } from '../auth/AuthContext.js'
import styles from './HomePage.module.css'

const ROLE_HOME = {
  student: '/student',
  teacher: '/teacher',
  admin: '/admin',
  pending: '/pending',
} as const

export default function HomePage(): JSX.Element {
  const { status, role, signIn } = useAuth()
  const [searchParams] = useSearchParams()
  const [signInPending, setSignInPending] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  // Surface auth errors handed back from /auth/callback via querystring.
  useEffect(() => {
    const e = searchParams.get('error')
    if (e) setErrorMessage(decodeURIComponent(e))
  }, [searchParams])

  if (status === 'authenticated' && role) {
    return <Navigate to={ROLE_HOME[role]} replace />
  }

  async function handleSignIn() {
    setErrorMessage(null)
    setSignInPending(true)
    try {
      const returnTo = searchParams.get('returnTo') ?? undefined
      await signIn(returnTo)
    } catch (err) {
      setSignInPending(false)
      setErrorMessage(err instanceof Error ? err.message : 'Sign-in failed')
    }
  }

  return (
    <main id="main-content" className={styles.root}>
      <div className={styles.hero}>
        <h1 className={styles.heading}>Study Decks</h1>
        <p className={styles.tagline}>School flashcards for grades 5–8</p>
        <Button type="button" size="lg" onClick={() => void handleSignIn()} loading={signInPending}>
          Sign in with Google
        </Button>
        {errorMessage && (
          <p role="alert" className={styles.error}>
            {errorMessage}
          </p>
        )}
        <p className={styles.notice}>
          Access requires a school Google Workspace account. Contact your teacher or IT
          administrator if you need help signing in.
        </p>
      </div>
    </main>
  )
}
